var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-btn',{on:{"click":_vm.downloadMembershipFile}},[_vm._v("Download Membership")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }